"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShouldRenderNotificationMenu = void 0;
var _auth = require("@ori/auth");
var _configurationContext = require("../context/configurationContext");
const useShouldRenderNotificationMenu = () => {
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    shouldDisplayNotificationIcon
  } = (0, _configurationContext.useAppConfig)();
  return !isAnonymousUser && !!shouldDisplayNotificationIcon;
};
exports.useShouldRenderNotificationMenu = useShouldRenderNotificationMenu;
